import React from 'react';
import styles from './ExtendedVariations.module.scss';
import Image from '../ImageComponent/Image';
import { addCustomPathToLink, sanitizeType, setVariant } from 'functions';

const ExtendedVariations = ({ api, type, animationData, currentVariant, setCurrentVariant }) => {
  return (
    <div
      data-aos={animationData?.animation}
      data-aos-offset={animationData?.animationOffset}
      data-aos-delay={animationData?.animationDelay}
      data-aos-duration={animationData?.animationDuration}
      data-aos-easing={animationData?.animationEasing}
      className={`${styles.containerCategory} ${sanitizeType(type, styles)}`}
    >
      {!!api.attributes?.variants &&
        Object.getOwnPropertyNames(api.attributes.variants).map((variantName) => (
          <div
            className={`${styles.wrapperCategory} ${currentVariant.name == variantName ? styles.activeCategory : ''}`}
            onClick={(_) => setCurrentVariant(api.attributes.variants[variantName])}
            key={variantName}
          >
            <div
              className={`${styles.statusCategory} ${
                variantName == 'low' ? styles.statusLowPrice : variantName == 'medium' ? styles.statusBenefic : styles.statusPremium
              }`}
            >
              <h3 className={styles.statusText}>{variantName == 'low' ? 'Niska cena' : variantName == 'medium' ? 'Korzystny' : 'Premium'}</h3>
            </div>
            {!!api.attributes?.variants[variantName]?.image && (
              <img
                className={styles.fullImage}
                src={addCustomPathToLink(api.attributes.variants[variantName].image.src, true)}
                alt={api.attributes.variants[variantName].image.alt}
              />
            )}
          </div>
        ))}
    </div>
  );
};

export default ExtendedVariations;
